import { useSearchParams } from 'react-router-dom';

export const useAppSearchParams = () => {
  const [searchParams] = useSearchParams();

  const contestId = Number(searchParams.get('contest_id') ?? '');
  const userId = Number(searchParams.get('user_id') ?? '');
  const pageId = Number(searchParams.get('page_id') ?? '');

  return {
    contestId,
    userId,
    pageId,
  };
};
